export default __webpack_public_path__ + "static/media/desktop-phone-top.028c4587.png";